import { useState } from 'react';
import { useAppData } from '../context/AppDataContext.jsx';
import { PHASE_LABEL_SHORT, phaseClass } from '../phases.js';

const TYPES = [
  { value: 'emicrania', label: 'Emicrania' },
  { value: 'tensivo', label: 'Tensivo' },
  { value: 'a-grappolo', label: 'A grappolo' },
  { value: 'altro', label: 'Altro' },
];

export default function HeadachePage() {
  const { episodes, addEpisode, deleteEpisode } = useAppData();
  const today = new Date().toISOString().slice(0, 10);

  const [form, setForm] = useState({
    date: today,
    intensity: 5,
    type: 'emicrania',
    note: '',
    triggers: '',
  });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  async function onSubmit(e) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await addEpisode({
        date: form.date,
        intensity: Number(form.intensity),
        type: form.type,
        note: form.note,
        triggers: form.triggers
          ? form.triggers.split(',').map((s) => s.trim()).filter(Boolean)
          : [],
      });
      setForm({ ...form, intensity: 5, note: '', triggers: '' });
    } catch (ex) {
      setErr(ex.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div>
      <div className="card">
        <h2>Nuovo episodio</h2>
        {err && <div className="error">{err}</div>}
        <form onSubmit={onSubmit}>
          <div className="field">
            <label>Data *</label>
            <input
              type="date"
              required
              value={form.date}
              onChange={(e) => setForm({ ...form, date: e.target.value })}
            />
          </div>
          <div className="field">
            <label>Intensit&agrave; (1-10): {form.intensity}</label>
            <input
              type="range"
              min="1"
              max="10"
              value={form.intensity}
              onChange={(e) => setForm({ ...form, intensity: e.target.value })}
            />
          </div>
          <div className="field">
            <label>Tipo</label>
            <select
              value={form.type}
              onChange={(e) => setForm({ ...form, type: e.target.value })}
            >
              {TYPES.map((t) => (
                <option key={t.value} value={t.value}>
                  {t.label}
                </option>
              ))}
            </select>
          </div>
          <div className="field">
            <label>Trigger (separati da virgola)</label>
            <input
              placeholder="es. stress, cioccolato, poco sonno"
              value={form.triggers}
              onChange={(e) => setForm({ ...form, triggers: e.target.value })}
            />
          </div>
          <div className="field">
            <label>Note</label>
            <textarea
              rows="3"
              value={form.note}
              onChange={(e) => setForm({ ...form, note: e.target.value })}
            />
          </div>
          <button type="submit" disabled={busy}>
            {busy ? 'Salvataggio…' : 'Salva episodio'}
          </button>
        </form>
      </div>

      <div className="card">
        <h2>Storico episodi</h2>
        {episodes.length === 0 ? (
          <p className="muted">Nessun episodio ancora registrato.</p>
        ) : (
          <ul className="list">
            {episodes.map((e) => (
              <li key={e.id}>
                <div className="row" style={{ justifyContent: 'space-between' }}>
                  <div>
                    <strong>{e.date}</strong> &middot; {e.type} &middot; intensit&agrave; {e.intensity}/10
                    {e.cycle && (
                      <span className={phaseClass(e.cycle.phase)} style={{ marginLeft: 6 }}>
                        {PHASE_LABEL_SHORT[e.cycle.phase]}
                      </span>
                    )}
                    {e.triggers && e.triggers.length > 0 && (
                      <div className="muted">Trigger: {e.triggers.join(', ')}</div>
                    )}
                    {e.note && <div className="muted">{e.note}</div>}
                  </div>
                  <button
                    className="danger"
                    onClick={() => {
                      if (window.confirm('Eliminare questo episodio?')) deleteEpisode(e.id);
                    }}
                  >
                    Elimina
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
